'use client';

import { useGetStreamer21Url } from '@/hooks/query/use-streaming-data';
import { useEffect } from 'react';
import { useStreamingStore } from '@/store/streaming';
import { VideoDeviceType } from '@/services/streaming.service';
import { StreamingBase } from '../streaming-base';
import { useStreamerWatchTimeTracking } from '@/hooks/query/use-reward-system';
import { SportMatchModel } from '@nf/types/odds';

export const Streamer21Streaming = ({ match, device, streamerRewardId }: { match: SportMatchModel, device: VideoDeviceType, streamerRewardId: number }) => {
	const [
		streamingSrc,
		channelList,
		streamingUrl,
		setStreamingUrl,
		streamingMatchId,
		isRefresh,
		setIsLoading
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.streamingUrl,
			state.setStreamingUrl,
			state.streamingMatchId,
			state.isRefresh,
			state.setIsLoading
		]
	);

	const streamingData = channelList?.find((item) => item?.value === streamingSrc);
	const sid = streamingData?.sid + '';
	const { refetch } = useGetStreamer21Url(sid);

	const getResponseUrl = (urlData: string) => {
		let url = '';
		if (streamingSrc.indexOf('-') > -1) {
			url = streamingSrc.split('-')[1] == '1' ? JSON.parse(urlData).Data[0] : JSON.parse(urlData).Data[1];
		} else {
			url = JSON.parse(urlData).Data;
		}
		setStreamingUrl(url);
		setIsLoading(false);
	}

	useEffect(() => {
		if (match.MatchId !== streamingMatchId || (streamingUrl && !isRefresh)) {
			return;
		}

		refetch().then((res) => {
			const urlData = res.data?.data;
			if (urlData) {
				getResponseUrl(urlData);
			}
		});
	}, [channelList, isRefresh, streamingSrc, streamingMatchId]);
	useStreamerWatchTimeTracking(streamerRewardId);

	return <StreamingBase device={device} match={match} />;
};

